module.exports = __webpack_public_path__ + "static/media/pedodonticssyllabus.70847e40.docx";